import ProductRoutes from './Product/router';
import PurchaseRoutes from './Purchase/router';
// import MissingSerailNumber from '../Invoice/views/MissingSerailNumber'

const Index = () => import('./index.vue');
const Home = () => import('./views/Home.vue');
const MissingSerailNumber = () => import('../Invoice/views/MissingSerailNumber');

let routes = [];

routes = routes.concat(ProductRoutes);
routes = routes.concat(PurchaseRoutes);
routes = routes.concat([
  {
    path: '',
    name: 'inventory-home',
    component: Home,
  },
  {
    path: 'missingSerialNumber/:id',
    name: 'missing-serial-number',
    component: MissingSerailNumber,
  },
]);

export default [
  {
    path: '/inventory',
    component: Index,
    title: 'Inventory',
    children: routes,
  },
];
